import React from 'react';
import './style.css';
import Typography from '@mui/material/Typography';



export default function PriceManagemantDescriptions() {
    return (
            // <ThemeProvider theme={theme}>
                // <CssBaseline />
                <div className='pricingDiv'>
                    <Typography className='text-center' mb={3}>
                        Please configure the pricing table with the appropriate pricing attributes applicable for the partner companies
                    </Typography>

                    <div className='pricingDiv'>
                        <Typography mt={1} className='pricingTextDiv'>
                            <span>Mode:</span> Indicates if price is active or not.
                        </Typography>

                        <Typography className='pricingTextDiv'>
                            <span>Band:</span> Pricing band associated with appropriate transfer limits.
                        </Typography>

                        <Typography className='pricingTextDiv'>
                            <span>Lower Limit:</span> Lowest amount within a band that can be transferred.
                        </Typography>

                        <Typography className='pricingTextDiv'>
                            <span>Upper Limit:</span> Highest amount within a band that can be transferred.
                        </Typography>

                        <Typography className='pricingTextDiv'>
                            <span>Transaction Fee:</span> Transaction fee applicable, during a transfer.
                        </Typography>

                        <Typography className='pricingTextDiv'>
                            <span>Promotion Fee:</span> Promotion fee applicable during a transfer when a promotion is running.
                        </Typography>

                        <Typography className='pricingTextDiv'>
                            <span>Promotion Start:</span> Start date of promotion.
                        </Typography>

                        <Typography mb={4} className='pricingTextDiv'>
                            <span>Promotion End:</span> End date of promotion.
                        </Typography>
                    </div>
                </div>
            // </ThemeProvider>

    );
}